$(document).ready(() => {
  const $enquiryForm = $('.listing--enquiry-form')
  const $interstateModal = $('.js-c-interstate_confirm')
  const stateOptions = ['NSW', 'QLD', 'NT', 'SA', 'WA', 'TAS', 'VIC', 'ACT']
  const listingStates = $('.listing_state').val()

  if ($enquiryForm.length === 0) {
    return
  }

  $enquiryForm.on('submit', (e, data) => {
    const enquiryLocation = $('#listings_enquiry_location_id option:selected').text()
    let enquiryState = null
    if ($.isEmptyObject(data) || data.triggered !== true) {
      stateOptions.forEach( function(value) {
        if (enquiryLocation.includes(value)) {
          enquiryState = value;
        }
      });

      if (listingStates.length !== 0 && enquiryState.length !== 0 && !listingStates.includes(enquiryState)) {
        $interstateModal.fadeIn('fast')
        e.preventDefault()
      }
    }
  })

  $('.js-c-interstate_confirm-ok').on('click', () => {
    $enquiryForm.trigger('submit', { triggered: true })
  })

  $('.js-c-interstate_confirm-cancel, .js-c-interstate_confirm-close').on('click', () => {
    $interstateModal.fadeOut('fast')
    $('.enquiry-submission-container .button').prop('disabled', false)
    grecaptcha.reset()
  })
})
